export const sanitizeTelemetryUrl = (url) => {
  let sanitizedUrl = url;

  sanitizedUrl = sanitizedUrl.replace(
    /\/ssn\/([^/?#]*)/i,
    '/ssn/**redacted**',
  );
  sanitizedUrl = sanitizedUrl.replace(
    /([?&#]secret_key=)[^&#]*/gi,
    '$1**redacted**',
  );
  sanitizedUrl = sanitizedUrl.replace(
    /([?&#]expectedUserHash=)[^&#]*/gi,
    '$1**redacted**',
  );
  sanitizedUrl = sanitizedUrl.replace(
    /([?&#]navigatorState=)[^&#]*/gi,
    '$1**redacted**',
  );

  return sanitizedUrl;
};
